/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Injectable } from '@angular/core';
import { ApiEntity } from 'app/api/models/api-entity.model';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { LookupList } from 'app/shared/models/lookup-list.model';
import { DataService } from 'app/shared/services/data.service';
import { environment } from 'environments/environment';
import { ExternalRaiseDefectModel } from '../models/external-raise-defect.model';
@Injectable({providedIn: 'root'})

export class ExternalRaiseDefectService extends DataService<any> {

  protected baseApiOverride = environment.baseUrlForRaisingDefect;
  protected apiPrefixOverride = environment.apiPrefixForRaisingDefect;
  protected includeAuthorizationHeader = false;
  softwareFeatureIdLookupData: any;


  constructor(apiDependencies: ApiDependenciesService) {
    super(apiDependencies);
  }

  baseEndpoint(): string {
    return `/software-projects/${environment.projectKeyForRaisingDefect}/defects`;
  }


  getLookupDataForDefectEndpoint(): string {
    return `${this.baseEndpoint()}/blank`;
  }

  getCreateEndpoint(): string {
    return `${this.baseEndpoint()}`;
  }

  public getCreateWithAttachmentsEndpoint(): string {
    return `${this.baseEndpoint()}/defect-with-attachments`;
  }


  async getLookupDataForDefect(): Promise<ApiEntity> {
    this.blockUI.start();  
    let model: ExternalRaiseDefectModel;

    await this
      .setEndpoint(this.getLookupDataForDefectEndpoint())
      .getSingle().then((response: any) => {
        model = response;
        this.blockUI.stop();
      })
      .catch(() => {
        this.blockUI.stop();
      });

    return Promise.resolve(model);
  }

  async addNew(item: any): Promise<any> {
    this.blockUI.start();
    let model: any;

    await this.setEndpoint(this.getCreateEndpoint())
      .save(item)
      .then((response) => {
        model = response;
        this.blockUI.stop();
      })
      .catch(() => {
        this.blockUI.stop();
      });

    return Promise.resolve(model);
  }

  async getSoftwareFeatureLookupList(filterCriteria: string): Promise<any> {
    let model: LookupList;

    if (!filterCriteria || typeof filterCriteria === 'object') {
      model = this.softwareFeatureIdLookupData;
      return Promise.resolve(model);
    }

    await this.setEndpoint(this.baseEndpoint() + `/software-feature-lookup-data?filter=${filterCriteria}`)
      .getSingle()
      .then((response) => {
        model = response;
      });

    return Promise.resolve(model);
  }

}
